import Swiper, { Navigation, Pagination } from '../../../../../../Build/node_modules/swiper';
import '../../../../../../Build/node_modules/swiper/swiper-vars.scss';
import '../../../../../../Build/node_modules/swiper/swiper.scss';
import '../../../../../../Build/node_modules/swiper/modules/pagination/pagination.scss';
import '../../../../../../Build/node_modules/swiper/modules/navigation/navigation.scss';

export class JobDetailsSliderClass {
    selector = '[data-job-featured-slider]';

    constructor() {

        this.init();
    }

    init() {
        const swiper = new Swiper(
            this.selector,
            {
                slidesPerView: 1,
                spaceBetween: 40,
                grabCursor: true,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                watchSlidesProgress: true,
                breakpoints: {
                    767: {
                        slidesPerView: 2,
                        spaceBetween: 40
                    },
                    1023: {
                        slidesPerView: 3,
                        spaceBetween: 40
                    },
                    1279: {
                        slidesPerView: 3,
                        spaceBetween: 40
                    }
                },
                modules: [
                    Navigation,
                    Pagination
                ],
                pagination: {
                    el: "[data-swiper-pagination]",
                    clickable: true,
                    dynamicBullets: true
                }
            }
        );
    }
}

document.addEventListener("DOMContentLoaded", function() {
    new JobDetailsSliderClass();
});
